import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {change, Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {filterStyles} from '../shared/styles-filter';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';

const renderSearchInput = ({input: {...inputProps}, ...props}) => {
    const styles = {
        textContainer: {
            position: 'relative'
        }
    };
    return (
        <span style={styles.textContainer}>
            <TextField
                {...inputProps}
                {...props}
                fullWidth
            />
        </span>
    )
};

/**
 * A form containing a Text component for Report Job search
 *
 */
class ReportJobsSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
            disableSubmit: true
        };
        this.handleReportSearchChange = this.handleReportSearchChange.bind(this);
        this.handleReportSearchClear = this.handleReportSearchClear.bind(this);
    }

    handleReportSearchChange(event, index, value) {
        this.setState({
            disableSubmit: (!(index !== '' && index.length > 2)),
            search: index
        }, () => {
            this.props.dispatch(change('reportJobFilterForm', 'report_job_search', this.state.search));
            if (this.state.search === '' && value !== '' && typeof this.props.onSearchSubmit === 'function') {
                this.props.onSearchSubmit({type: 'search', value: ''});
            }
        });
    }

    handleReportSearchSubmit = () => {
        const searchValue = this.state.search;
        if (searchValue !== '' && searchValue.length > 2 && typeof this.props.onSearchSubmit === 'function') {
            this.props.onSearchSubmit({type: 'search', value: this.state.search});
        }
    };

    handleReportSearchClear() {
        this.setState({
            disableSubmit: true,
            search: ''
        }, () => {
            this.props.dispatch(change('reportJobFilterForm', 'report_job_search', this.state.search));
            if (typeof this.props.onSearchSubmit === 'function') {
                this.props.onSearchSubmit({type: 'search', value: ''});
            }
        });
    }

    render() {
        const {instructions} = this.props;
        const {disableSubmit, search} = this.state;

        const styles = {
            button: {marginRight: '1em'},
            field: {display: 'inline-block', width: 300, maxWidth: '50%', marginRight: '1em'},
            instructions: {fontSize: 12, margin: '1em 0 -1em 0'}
        };

        return (
            <div style={filterStyles.reportFilter}>
                {instructions &&
                    <div style={styles.instructions}>
                        If desired, search Report Jobs.
                    </div>
                }
                <Field
                    name="filter_report_job_search"
                    type="text"
                    component={renderSearchInput}
                    floatingLabelText="Search Report Jobs"
                    value={search}
                    onChange={this.handleReportSearchChange}
                    style={styles.field}
                />
                <RaisedButton
                    type="button"
                    primary
                    size="medium"
                    disabled={disableSubmit}
                    onClick={this.handleReportSearchSubmit}
                    label="Search"
                    style={styles.button}
                />
            </div>
        );
    }
}

ReportJobsSearch.propTypes = {
    addField: PropTypes.bool,
    clearable: PropTypes.bool,
    fullWidth: PropTypes.bool,
    instructions: PropTypes.bool,
    onFilterChange: PropTypes.func,
    onSearchSubmit: PropTypes.func,
};

ReportJobsSearch.defaultProps = {
    addField: true,
    clearable: true,
    fullWidth: false,
    instructions: false
};

const enhance = compose(
    connect(),
    reduxForm({
        form: 'reportJobFilterForm',
        enableReinitialize: true
    })
);

export default enhance(ReportJobsSearch);



// WEBPACK FOOTER //
// ./src/Fuse/components/ReportJobsSearch.js